/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { XPTransactionHistoryResponsePagination } from './XPTransactionHistoryResponsePagination';
import {
    XPTransactionHistoryResponsePaginationFromJSON,
    XPTransactionHistoryResponsePaginationFromJSONTyped,
    XPTransactionHistoryResponsePaginationToJSON,
    XPTransactionHistoryResponsePaginationToJSONTyped,
} from './XPTransactionHistoryResponsePagination';
import type { XPTransactionHistoryItem } from './XPTransactionHistoryItem';
import {
    XPTransactionHistoryItemFromJSON,
    XPTransactionHistoryItemFromJSONTyped,
    XPTransactionHistoryItemToJSON,
    XPTransactionHistoryItemToJSONTyped,
} from './XPTransactionHistoryItem';

/**
 * 
 * @export
 * @interface XPTransactionHistoryResponse
 */
export interface XPTransactionHistoryResponse {
    /**
     * 
     * @type {Array<XPTransactionHistoryItem>}
     * @memberof XPTransactionHistoryResponse
     */
    transactions?: Array<XPTransactionHistoryItem>;
    /**
     * 
     * @type {XPTransactionHistoryResponsePagination}
     * @memberof XPTransactionHistoryResponse
     */
    pagination?: XPTransactionHistoryResponsePagination;
    /**
     * Applied time filter
     * @type {string}
     * @memberof XPTransactionHistoryResponse
     */
    timeFilter?: string;
    /**
     * Start date of filter period
     * @type {Date}
     * @memberof XPTransactionHistoryResponse
     */
    startDate?: Date;
    /**
     * End date of filter period
     * @type {Date}
     * @memberof XPTransactionHistoryResponse
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the XPTransactionHistoryResponse interface.
 */
export function instanceOfXPTransactionHistoryResponse(value: object): value is XPTransactionHistoryResponse {
    return true;
}

export function XPTransactionHistoryResponseFromJSON(json: any): XPTransactionHistoryResponse {
    return XPTransactionHistoryResponseFromJSONTyped(json, false);
}

export function XPTransactionHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): XPTransactionHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': json['transactions'] == null ? undefined : ((json['transactions'] as Array<any>).map(XPTransactionHistoryItemFromJSON)),
        'pagination': json['pagination'] == null ? undefined : XPTransactionHistoryResponsePaginationFromJSON(json['pagination']),
        'timeFilter': json['timeFilter'] == null ? undefined : json['timeFilter'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function XPTransactionHistoryResponseToJSON(json: any): XPTransactionHistoryResponse {
    return XPTransactionHistoryResponseToJSONTyped(json, false);
}

export function XPTransactionHistoryResponseToJSONTyped(value?: XPTransactionHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': value['transactions'] == null ? undefined : ((value['transactions'] as Array<any>).map(XPTransactionHistoryItemToJSON)),
        'pagination': XPTransactionHistoryResponsePaginationToJSON(value['pagination']),
        'timeFilter': value['timeFilter'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

